module.exports = __webpack_public_path__ + "assets/a-1-shilibiao.c5596d5f.svg";